import React from 'react';
import { Card } from 'react-bootstrap'
import { Button } from 'react-bootstrap'
import './InfoCard.css';

class InfoCard extends React.Component {

  showTagButtons = () => {
    let buttons = []
    this.props.tags.map((tag, index) => {
      buttons.push(<Button key={index} className="tag"> {tag}</Button>)
    })
    return buttons;
  }
  
  render() {
    return (
      <Card id="cardFrame" onClick = {() => window.location = this.props.link}>
        <div id="cardHeader">
          <Button className="category"> {this.props.category} </Button>
          {this.showTagButtons()}
        </div>
        <div id="cardMiddle">
          <div id="cardText">
            <h4> {this.props.headline} </h4>
            <p> {this.props.bodytext} </p>
          </div>
        </div>
      </Card>
    )
  }
}

export default InfoCard;